import React, { Component } from 'react'
import styled from 'styled-components'

// TODO: Move this component to UI Library
class SubTitle extends Component {
  render () {
    return (
      <TextElement className={this.props.className}>
        {this.props.text}{this.props.children}
      </TextElement>
    )
  }
}
export default SubTitle

const TextElement = styled.h3`
  line-height: 28px;
  font-size: 16px;
  letter-spacing: 1px;
  color: #010101;
  text-transform: uppercase;
  font-weight: normal;
  text-align: center;
  margin: 0;
  font-size: 100;
  position: relative;

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 14px;
    max-width: 70%;
    text-align: center;
    margin: 0 auto;
  }

  @media screen and (max-width: 468px) {
    font-size: 10px;
    line-height: 14px;
  }
`



// WEBPACK FOOTER //
// ./src/components/SubTitle/index.js